function mtInitReveals() {
  var els = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function mtInitComparador() {
  var wraps = document.querySelectorAll('.mt-comparador');
  wraps.forEach(function (wrap) {
    var handle = wrap.querySelector('.mt-comparador-asa');
    var after = wrap.querySelector('.mt-comparador-despues');
    var input = wrap.querySelector('.mt-comparador-input');
    if (!handle || !after || !input) return;
    function set(pct) {
      pct = Math.min(100, Math.max(0, pct));
      after.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
    }
    input.addEventListener('input', function () { set(Number(input.value)); });
    set(Number(input.value || 50));
  });
}

function mtInitContadores() {
  var els = document.querySelectorAll('.mt-contador');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      var el = entry.target;
      var target = Number(el.dataset.target || '0');
      var dur = 1200;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min(1, (ts - start) / dur);
        el.textContent = Math.floor(progress * target).toLocaleString();
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = target.toLocaleString();
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function mtInitFaq() {
  var items = document.querySelectorAll('.mt-faq-item');
  items.forEach(function (item) {
    var pregunta = item.querySelector('.mt-faq-pregunta');
    if (!pregunta) return;
    pregunta.addEventListener('click', function () {
      var abierto = item.classList.contains('mt-faq-abierto');
      items.forEach(function (i) { i.classList.remove('mt-faq-abierto'); });
      if (!abierto) item.classList.add('mt-faq-abierto');
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  mtInitReveals();
  mtInitComparador();
  mtInitContadores();
  mtInitFaq();
});
